import { CartProviderProps } from "app/providers/CartProvider";
import { getProductPageSlug } from "shared/utils/door";
import { zakelijkDoorCodes } from "features/option-controls/door-width-controls/ZakelijkHelper";
import { findStaander } from "entities/configurator/model/staander";

export const getProductEditLink = (
  cartContext: CartProviderProps,
  productIndex: number,
) => {
  const { getCartProduct, getCart } = cartContext;
  const cart = getCart();

  const product = getCartProduct(productIndex);
  if (!product) return "#";

  const {
    doorType,
    doorLayout,
    doorColor,
    glassType,
    doorHandle,
    extraOptions,
    measurements,
    eigenwijsLayout,
  } = product;

  const query: string[] = [];

  query.push(`door=${doorType.code}`);
  query.push(`layout=${doorLayout.code}`);
  query.push(`color=${doorColor.code}`);
  query.push(`glass=${glassType.code}`);
  query.push(`handle=${doorHandle.code}`);
  if (eigenwijsLayout) query.push(`eigenwijs_layout=${eigenwijsLayout.code}`);
  const staander = findStaander(
    measurements.widths,
    measurements.verticalBeams,
    doorType.code,
  );
  if (extraOptions.length) {
    query.push(`extra=${encodeURIComponent(JSON.stringify(extraOptions))}`);
  }
  if (!cart.sampleSale) query.push(`configuration=${productIndex}`);

  if (measurements.height) query.push(`height=${measurements.height}`);
  if (measurements.widths)
    query.push(
      `width=${encodeURIComponent(JSON.stringify(measurements.widths))}`,
    );

  if (staander) query.push(`staander=${staander}`);

  if (doorLayout.code === "eigenwijs") {
    if (measurements.beams)
      query.push(
        `beam=${encodeURIComponent(JSON.stringify(measurements.beams))}`,
      );
  }

  if (cart.isSelfAssembly) {
    query.push(`isSelfAssembly=true`);
    if (product.label) query.push(`label=${product.label}`);
    if (measurements.sponningsBreedte)
      query.push(`sponningsBreedte=${product.measurements.sponningsBreedte}`);
    if (measurements.sponningsHoogte)
      query.push(`sponningsHoogte=${product.measurements.sponningsHoogte}`);

    if (doorType.code === "opdekdeur") {
      query.push(`rotation=${product.measurements.rotation}`);
      query.push(`frameType=${product.measurements.frameType}`);
      query.push(`hingeAmount=${product.measurements.hingeAmount}`);
    } else if (doorType.code === "schuifdeur") {
      query.push(`locationPlacement=${product.measurements.locationPlacement}`);
      query.push(`sparingPlafond=${product.measurements.sparingPlafond}`);
      query.push(`slideToWall=${product.measurements.slideToWall}`);
    }
  }

  const productPageURL = zakelijkDoorCodes.includes(doorType.code)
    ? "/zakelijk/producten/"
    : "/producten/";
  const uri = `${productPageURL}${getProductPageSlug(doorType.code)}?`;

  return `${window.location.origin}${uri}${query.join("&")}`;
};
